import { Calendar } from 'lucide-react';
import { DailyPlans } from './DailyPlans';
import { AutonomousFeed } from '../AutonomousFeed';

export function ExecutionWorkQueue({ t }: { t: any }) {
  const isZh = t?.langCode !== 'en';
  return (
    <div className="h-full overflow-y-auto custom-scrollbar p-8">
      <section className="xf-surface min-h-full rounded-3xl bg-black/20 p-5">
      <div className="mb-5 flex items-center justify-between gap-3">
        <div>
          <div className="flex items-center gap-2 text-lg font-black uppercase tracking-widest text-white/85">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl border border-celestial-saturn/20 bg-celestial-saturn/10 text-celestial-saturn">
              <Calendar size={18} />
            </span>
            {isZh ? '小枫 学习与吸收' : '小枫 Learning & Absorption'}
          </div>
          <p className="mt-1 max-w-2xl text-sm leading-relaxed text-white/42">
            {isZh
              ? '这里是小枫自己创建、执行和沉淀知识的学习流：她会从上下文、资料和记忆里持续吸收新东西。'
              : 'This is 小枫\'s own learning stream: she creates plans, executes them, and absorbs reusable knowledge from context, files, and memory.'}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-[0.95fr_1.25fr]">
        <DailyPlans t={t} embedded />
        <AutonomousFeed expanded />
      </div>
      </section>
    </div>
  );
}
